<template>
  <CoreDrawer
    :value="value"
    :width="667"
    title="Клуб ПроДокторов"
    :attach="attach"
    @input="$emit('input', $event)"
  >
    <template #title-append>
      <v-img
        src="/static/_v1/pd/icons/ui-kit/club/club-percent.svg"
        class="ml-2"
        width="24"
        height="24"
        alt="Иконка Процент Клуба"
      />
    </template>
    <component
      :is="ClubInfoComponent"
      :class="isMobile ? 'py-4' : 'pa-6'"
      :pdf-data="{
        coupon: '/static/_v1/pd/documents/pdf/club/Правила_использования_купонов.pdf',
        participation: '/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе_ПроДокторов.pdf',
      }"
    />
  </CoreDrawer>
</template>

<script setup lang="ts">
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import ClubInfoMobile from 'www/vue_components/mobile/Club/components/dependencies/ClubInfoModal/ClubInfoModalContent.vue'
import ClubInfoDesktop from 'www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/ClubDesktopInfoModalContent.vue'

defineEmits(['input'])
defineProps<{
  value: boolean
  attach?: string
}>()

const isMobile = window.MOBILE_VERSION
const ClubInfoComponent = isMobile ? ClubInfoMobile : ClubInfoDesktop
</script>
